module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-01-jp.30dd05cf02291dffa03200ced0267909.png";